module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cpytxt"
  }), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }), _vm._v(" "), _c('p', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rpre"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Preface"
    }
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rack"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rintro"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction"
    }
  }, [_vm._v("Introduction: How Cognitive Science Changes Ethics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "display"
  }), _c('span', {
    staticClass: "space"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_vm._v("Reason as Force: The Moral Law Folk Theory")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "display"
  }), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metaphoric Morality")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _c('span', {
    staticClass: "display"
  }), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Metaphoric Basis of Moral Theory")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _c('span', {
    staticClass: "display"
  }), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beyond Rules")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _c('span', {
    staticClass: "display"
  }), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Impoverishment of Reason: Our Enlightenment Legacy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _c('span', {
    staticClass: "display"
  }), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What’s Wrong with the Objectivist Self")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _c('span', {
    staticClass: "display"
  }), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Narrative Context of Self and Action")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _c('span', {
    staticClass: "display"
  }), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moral Imagination")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _c('span', {
    staticClass: "display"
  }), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Living without Absolutes: Objectivity and the Conditions for Criticism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _c('span', {
    staticClass: "display"
  }), _c('span', {
    staticClass: "space2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preserving Our Best Enlightenment Moral Ideals")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rnote"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rind"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbca8086","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 66
// module chunks = 0